import { Box, styled } from '@mui/material';

export const InputBox = styled(Box, {
  shouldForwardProp: property => property !== 'empty',
})<{ disabled?: boolean; empty?: boolean }>(({ theme, disabled, empty }) => ({
  padding: '2px 6px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  ...(empty && {
    height: '40px',
  }),
  '&:hover': {
    borderColor: disabled ? theme.palette.divider : theme.palette.secondary.main,
  },
}));
